import {Auction, User} from "domain-models"
import React from "react"
import BidAgentModal from "views/Auctions/BidAgentModal"
import BidButton from "views/Auctions/BidButton"
import {connect} from "react-redux"
import {GlobalState} from "../../state"
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {faPrint} from "@fortawesome/free-solid-svg-icons"
import Trans from '../Trans'


type BidButtonsProps = {
  showBidAgent?: boolean
  auction: Auction
  user: User
}

type BidButtonsState = {
  showBidAgent: boolean
  bidButtons: Array<any>
}

class BidButtons extends React.Component<BidButtonsProps, BidButtonsState> {
  private user = this.props.user

  constructor(props: BidButtonsProps) {
    super(props)
    this.state = {
      showBidAgent: false,
      bidButtons: []
    }
  };

  showBidAgent = () => {
    this.setState({showBidAgent: true})
  }

  hideBidAgent = () => {
    this.setState({showBidAgent: false})
  }

  printPickupCode = () => {
    window.open('/auctions/'+this.props.auction.Id+'/pickup-code/print', 'blank')
  }

  render() {
    const auction = this.props.auction

    if (auction.status === 'not-started-yet') {
      return null
    }

    // Show cancelled message if auction was cancelled
    if (auction.status === 'cancelled') {
      return (
        <div className="w-full">
          <div className="rounded bg-red-100 border border-red-400 text-red-700 px-4 py-3 text-center">
            <p className="font-bold"><Trans>Auktion abgebrochen</Trans></p>
            <p className="text-sm"><Trans>Diese Auktion wurde vom Verkäufer abgebrochen.</Trans></p>
          </div>
        </div>
      )
    }

    return auction.status === 'ended' ?
      (
        auction.round.winner && auction.round.winner.BidderId === this.props.user.ars_id && auction.round.PickupCode ?
          (
            <div className="w-full">
              <div className="font-semibold text-xs text-green-600 flex flex-row justify-between flex-wrap">
                <div className="w-full">
                  <button className={"w-full rounded bg-green-200 hover:bg-green-300 text-green-700 px-4 py-2 font-semibold whitespace-no-wrap shadow text-lg"} onClick={() => this.printPickupCode()}>
                    <Icon icon={faPrint}/> <Trans>Abholschein drucken</Trans>
                  </button>
                </div>
              </div>
            </div>
          )
          : null
      )
      : (
        <div className="w-full">
          {
            auction.round.Type === 0 ? (
              <div>
                {
                  !auction.round.bid ?
                    <BidButton title="Gebot abgeben" auction={this.props.auction}/>
                    :
                    !auction.round.bid.OldBid ?
                      <BidButton title='Gebot einmalig Ändern' auction={this.props.auction} tertiary={true}/>
                      : null
                }
              </div>
            ) : auction.round.Type === 1 ?
              (
                <div className="w-full">
                  {
                    auction.highestBidder && auction.highestBidder.BidderId === this.user.ars_id && !auction.round.PriceCall ?
                      <div className="font-semibold text-xs text-green-600 flex flex-row justify-between flex-wrap">
                        <div className="w-full">
                          {
                            auction.round.agents.length ?
                              <button className={"w-full rounded bg-green-200 hover:bg-green-300 text-green-700 px-4 py-2 font-semibold whitespace-no-wrap shadow text-lg"} onClick={() => this.showBidAgent()}>
                                <Trans>Biet-Agent aktiv</Trans>
                              </button>
                              :
                              <button className={"w-full rounded bg-blue-600 hover:bg-blue-800 text-blue-100 px-4 py-2 font-semibold whitespace-no-wrap shadow text-lg"} onClick={() => this.showBidAgent()}>
                                <Trans>Biet-Agent</Trans>
                              </button>
                          }
                        </div>
                      </div>
                      :
                      <BidButton auction={this.props.auction} title="Gebot abgeben"/>
                  }
                </div>
              )
              : auction.round.Type === 2 ?
                (
                  <div className="w-full">
                    <BidButton auction={this.props.auction} title="Sofort kaufen"/>
                  </div>
                )
                : null
          }

          <div>
            {
              this.state.showBidAgent ?
                <BidAgentModal auction={auction} hideModal={this.hideBidAgent}/>
                : null
            }
          </div>
        </div>
      )
  }
}

export default connect((state: GlobalState) => ({
  user: state.user
}))(BidButtons)
